// Thin wrapper around Google gtag so components stay dependency-free
// and we don't crash if gtag is blocked (ad-blockers) or not yet loaded.

export function track(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    // swallow — analytics must never break the UX
  }
}
